<template>
    <div>
        <div class="p-5 mb-4 text-sm text-yellow-700 bg-yellow-100 rounded-lg" role="alert">
            <span class="font-bold text-xl"><i class="fas fa-exclamation-triangle mr-1"></i> {{$t('mes_produits.upload_doc.une_action_est_requise_de_votre_part')}}</span>
            <hr class="my-5 border-yellow-800">
            <p class="text-lg mb-4" v-if="comment">{{comment}}</p>
            <sav-input v-model="file" type="file" :label="$t('mes_produits.upload_doc.fichier')" />
            <sav-input v-model="message" type="textarea" class="mt-5" :label="$t('mes_produits.upload_doc.message_complementaire')" />
            <button class="mt-3 text-white bg-green-500 hover:bg-green-600 duration-200 px-3 py-2.5 text-sm font-light border-red-200 rounded" @click="sendData">
                <i class="fas fa-check mr-1"></i> {{$t('mes_produits.upload_doc.envoyer')}}
            </button>
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import eventHub from '@/eventHub'

export default {
    props: {
        comment: {required: true},
        idCase: {required: true}
    },

    data() {
        return {
            file: null,
            message: null,
        }
    },

    methods: {
        async sendData() {
            if (this.file) {
                await apiService.post('rep_client', {
                    id_file: this.file.id,
                    comment: this.message,
                    id_case: this.idCase
                })
                eventHub.$emit('refresh-product-list')
            } else {
                this.$toast.error('Fichier requis')
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/companies/default/views/user/product/FolderActions.vue/WaitingDocument.vue